import { MediaQuery } from '@maxpreps/shared/styles/breakpoint';
import styled from 'styled-components';

/* Adds vertical margin between immediate children */
const StyledLayoutGapManager = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  ${MediaQuery.Desktop} {
    gap: 16px;
  }
`;

export default StyledLayoutGapManager;
